import React from 'react'

type MessageContextProps = {
  message: { value: string; type: string; status: string; title: string }
  setMessage: (message: { value: string; type: string; status: string; title: string }) => void
  errorMessage: string
  setErrorMessage: (message: string) => void
}

const MessageContext = React.createContext<MessageContextProps>({
  message: { value: '', type: '', status: '', title: '' },
  errorMessage: '',
  setMessage: () => {},
  setErrorMessage: () => {},
})

export const MessageProvider = MessageContext.Provider
export const MessageConsumer = MessageContext.Consumer
export default MessageContext
